module.exports = __webpack_public_path__ + "static/videos/etch_002.dcaaf22.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/etching/etch_002.mp4
// module id = 464
// module chunks = 1